import React, { Component } from 'react';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

import Social from './';
import RequestManager from '../../requests/RequestManager';
import UserTask from '../../requests/tasks/social/user/userTask';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import Utils from '../../utils/Utils';
import FollowingsTask from '../../requests/tasks/social/followings/followingsTask';
import UtilsSocial from '../../utils/social/Social';
import UtilsProfile from '../../utils/Profile';
import { showModal, MODAL_SOCIAL_LEVEL, AAF_MODAL_ERROR } from '../../actions/modal';
import { addOwnFollowingsToState, incOwnFollowings, decOwnFollowings } from '../../reducers/social';
import Asset from "../../requests/apa/Asset";
import Translator from "../../requests/apa/Translator";
import CCOM from '../../devices/nagra/CCOM';
import {setMetricsEvent} from '../../actions/metrics';

class SocialContainer extends Component {

  constructor(props) {
    super(props);

    const emails = this.getIrdAllMailInfo();
    const gameId = '585997d2c39004e67987c60d';
    const { params } = props.match;
    const { gamificationId } = params;
    const gamificationIdUserlogged = !this.props.user.isAnonymous ? props.user.gamification_id : gamificationId;
    const isCurrentUser = gamificationId === gamificationIdUserlogged;

    this.state = {
      isFetching: true,
      initialLoad: true,
      gameId,
      emails,
      userSocial: null,
      isCurrentUser,
      gamificationIdCurrentUser: gamificationId,
      gamificationIdUserlogged,
    };

    this.showLevelUpModal = this.showLevelUpModal.bind(this);
    this.getCurrentUserProfileData = this.getCurrentUserProfileData.bind(this);
    this.setMetricsEvent=this.setMetricsEvent.bind(this);
  }

  componentWillMount() {

    if (!UtilsProfile.isSocialConfigEnable()) {
      this.props.history.replace('homeuser');
    }
  }

  componentWillReceiveProps(nextProps) {
    const { gamificationIdCurrentUser } = this.state;
    const { gamificationId } = nextProps.match.params;
    if (gamificationIdCurrentUser !== gamificationId) {
      this.setState({ isFetching: true });
      this.getCurrentUserProfileData(gamificationId, true);
    }
  }

  componentDidMount() {
    this.getCurrentUserProfileData(this.state.gamificationIdCurrentUser, true);
  }

  getIrdAllMailInfo() {
    if(CCOM && CCOM.ConditionalAccess && CCOM.ConditionalAccess.getIrdAllMail) {
      const getAllMail = CCOM.ConditionalAccess.getIrdAllMail();
      const emails = Array.isArray(getAllMail.mailInfo) ? getAllMail.mailInfo : [ getAllMail.mailInfo ];
      DeviceStorage.setItem('messages_nagra', JSON.stringify({ count: emails.length || 0 }));
      return emails;
    } else {
      DeviceStorage.setItem('messages_nagra', JSON.stringify({ count: 0 }));
      return [];
    }
  }

  async getCurrentUserProfileData(gamificationIdCurrentUser, initialLoad = false) {
    if(!gamificationIdCurrentUser) {
      this.props.history.replace('homeuser');
    }
    const { gameId, gamificationIdUserlogged } = this.state;
    const isCurrentUser = gamificationIdCurrentUser === gamificationIdUserlogged;
    const userLevelInfo = DeviceStorage.getItem('loginInfo.userLevelInfo') || '{}';
    const previousLevel = JSON.parse(userLevelInfo);
    const socialLevelsByCountry = Utils.getApaMetadataKey('social_levels', null)

    try {
      const userTask = new UserTask( { gamificationId: gamificationIdCurrentUser });
      const ownFollowingsTask = new FollowingsTask({ gameId }, gamificationIdUserlogged);
      const userData = await RequestManager.addRequest(userTask);
      const ownFollowings = initialLoad ? await RequestManager.addRequest(ownFollowingsTask) : null;

      if (ownFollowings) {
        this.props.addOwnFollowingsToState(ownFollowings.data);
      }

      const currentLevel = isCurrentUser ?
        UtilsSocial.socialLevel(socialLevelsByCountry, userData.data, gameId)
        : null;

      if(!this.props.user.isAnonymous) this.showLevelUpModal(currentLevel, previousLevel);
      const userSocial = ( !isCurrentUser && Boolean(userData.data.config.isPrivate) ) ? null : userData.data;

      this.setState({
        isFetching: false,
        userSocial,
        isCurrentUser,
        gamificationIdCurrentUser
      })

    } catch(e) {
      this.props.showModal({
        modalType: AAF_MODAL_ERROR,
        modalProps: { content: e }
      });
    }
  }

  showLevelUpModal (currentLevel = {}, previousLevel = {}) {
    if (currentLevel && previousLevel) {
      const levelChanged = (Number(currentLevel.level) !== Number(previousLevel.levelNumber));
      if (levelChanged) {
        const content = `
        <div>
          <div>${Translator.get('social_level', 'Nivel')} : ${currentLevel.level}</div>
          <div>${Translator.get(currentLevel.level_name, 'level')}</div>
          <div>${Translator.get('sc_next_level', 'Proximo Nivel')} : ${Translator.get(currentLevel.nextLevel, 'default')}</div>
        </div>
      `;

        this.props.showModal({
          modalType: MODAL_SOCIAL_LEVEL,
          modalProps: {
            asset: currentLevel.level_asset,
            title: Translator.get('sc_congratulations', 'Felicidades'),
            content,
          }
        });

        const userLevelInfo = JSON.stringify({ levelNumber: currentLevel.level });
        DeviceStorage.setItem('loginInfo.userLevelInfo', userLevelInfo);
      }
    }
  }

  setMetricsEvent(payload){
    this.props.setMetricsEvent(payload);
  }

  render() {
    if (this.state.isFetching) {
      return null;
    }

    const { gameId, emails, userSocial, isCurrentUser, gamificationIdUserlogged } = this.state;
    return (
      <Social
        getLinks={this.props.getLinks}
        gameId={ gameId }
        emails={ emails }
        userSocial={ userSocial }
        isCurrentUser={ isCurrentUser }
        ownFollowings={ this.props.social.ownFollowings }
        gamificationIdUserlogged={ gamificationIdUserlogged }

        showModal={ showModal }
        incOwnFollowings={ incOwnFollowings }
        decOwnFollowings={ decOwnFollowings }
        addOwnFollowingsToState={ addOwnFollowingsToState }
        setMetricsEvent={this.setMetricsEvent}
        user={ this.props.user }

        nameFromisloggedin={this.props.user && this.props.user.firstname ? this.props.user.firstname + " " + this.props.user.lastname:null}
      />
    )
  }

}

const mapStateToProps = (state) => ({
  user: state.user,
  social: state.social,
});
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal,
  incOwnFollowings,
  decOwnFollowings,
  addOwnFollowingsToState,
  setMetricsEvent
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(SocialContainer);



// WEBPACK FOOTER //
// ./src/containers/Social/SocialContainer.jsx